import React from 'react';
import { Quote, Star } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-emerald-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-200 bg-white text-emerald-700 text-xs font-semibold uppercase tracking-widest">
            Testimonials
          </div>
          <h2 className="mt-5 text-4xl md:text-5xl font-extrabold text-[#0b1a1a] leading-tight">
            What our <span className="text-emerald-600">Partners</span> say
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="relative bg-white rounded-3xl p-8 border border-slate-100 shadow-sm hover:shadow-xl hover:shadow-emerald-100 hover:-translate-y-1 transition-all duration-300">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-emerald-100" fill="currentColor" />
              <div className="flex gap-0.5">
                {[...Array(5)].map((_,k) => <Star key={k} className="w-4 h-4 text-amber-400" fill="currentColor" />)}
              </div>
              <p className="mt-5 text-slate-700 leading-relaxed">&ldquo;{t.quote}&rdquo;</p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-slate-100">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 grid place-items-center text-white font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-bold text-[#0b1a1a]">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
